// extracted by mini-css-extract-plugin
export var button = "_1e-1";
export var featuredLink = "_1e-4";
export var spinner = "_1e-2";
export var spinnerContainer = "_1e-3";
export var text = "_1e-0";